<template>
  <div class="print-step2">
    <h4>乘机人信息</h4>
    <components v-bind:is="compName" :checkinList="checkinList" @selectTrip="selectTrip"></components>
    <p style="text-align: center" v-if="!compName">
      <a-spin tip="正在加载乘机人信息。。。" />
    </p>

    <div class="print-operation">
      <a-button v-if="!ready" size="large" class="print-btn">取消值机</a-button>
      <a-button
        v-else
        type="primary"
        size="large"
        class="print-btn"
        @click="handleCheckinCancel"
      >取消值机</a-button>
    </div>
  </div>
</template>
<script>
import { checkinTrip, checkinData, checkinCancel } from '@/apis/checkin'
import moment from 'moment'
import CheckInList from '@/components/checkin/selectCheckin'

export default {
  props: {
    stepData: Object
  },
  data () {
    return {
      compName: '',
      checkinList: [],
      selectIndex: -1,
      ready: false,
      flightData: {}
    }
  },
  created () {
    this.getFlightData()
  },
  methods: {
    async getFlightData () {
      const data = {
        ...this.stepData
      }
      if (data.certType === 'ID_CARD') {
        data.certType = 'NI'
      }
      try {
        const result = await checkinTrip({
          ...data,
          slideCaptcha: new Date().getTime()
        })
        result.forEach((item, index) => {
          if (item.depTime) {
            let timeFormat = moment(item.depTime).format()
            item.depTimeFormat = timeFormat.split('T')[1].slice(0, 5)
            item.depDateFormat = timeFormat.split('T')[0]
          } else {
            item.depTimeFormat = ''
            item.depDateFormat = ''
          }
          if (item.arrTime) {
            item.arrTimeFormat = moment(item.arrTime).format().split('T')[1].slice(0, 5)
          } else {
            item.arrTimeFormat = ''
          }

          if (item.status === 'OPEN FOR USE') {
            item.statusText = '可值机'
            item.disabled = true
          } else {
            if (item.status === 'CHECKED IN') {
              item.statusText = '已值机'
            } else {
              item.statusText = '不可值机'
              item.disabled = true
            }
          }
          this.checkinList.push(item)
        })
        this.compName = 'CheckInList'
      } catch (err) {
        this.$message.error(err.message)
        this.$emit('callback', 1)
      }
    },
    async selectTrip (index) {
      this.isSelect = true
      this.selectIndex = index
      let flight = this.checkinList[index]
      this.flightData = {
        airline: flight.airline,
        arrCode: flight.arrCode,
        cabin: flight.cabin,
        certNo: flight.certNo,
        depCode: flight.depCode,
        depTime: flight.depTime,
        flightNo: flight.flightNo,
        ticketNo: flight.ticketNo,
        certType: 'TN' // 写死证件类型为票号
      }
      try {
        const result = await checkinData(this.flightData)
        if (!result.seatNumber) {
          this.$message.error('您尚未在此航班值机，无法进行取消值机操作')
        } else {
          this.flightData.seatNum = result.seatNumber
          this.flightData.passengerName = result.passengerName
          this.ready = true
        }
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    async handleCheckinCancel () {
      let data = Object.assign({}, this.flightData)
      const psgData = this.checkinList[this.selectIndex]
      data.tourIndex = psgData.tourIndex
      try {
        await checkinCancel(data)
        this.$message.success('取消值机操作成功！', 2).then(() => {
          window.__MICRO_ROOT__?.router.push({ pathname: '/' })
        })
      } catch (err) {
        this.$message.error(err.message)
      }
    }
  },
  components: {
    CheckInList
  }
}
</script>
<style lang="less" scoped>
.print-step2 {
  h4 {
    margin-bottom: 15px;
    font-size: 24px;
    line-height: 32px;
    font-weight: bold;
  }
  .print-operation {
    padding-top: 50px;
    text-align: center;
    .print-btn {
      padding: 0 40px;
    }
  }
}
@media only screen and (max-width: 768px) {
  .print-step2 {
    h4 {
      margin-left: 10px;
    }
    .print-operation {
      .print-btn {
        display: block;
        width: 96%;
        margin: 0 auto;
      }
    }
  }
}
</style>
